/**
 * Mapeamento de códigos de moeda para símbolos
 */
export const currencyMap: Record<string, string> = {
    'BRL': 'R$',
    'USD': '$',
    'EUR': '€',
    'GBP': '£',
    'JPY': '¥',
    'CAD': 'C$',
    'AUD': 'A$',
    // Adicione mais moedas conforme necessário
};

/**
 * Obtém o símbolo da moeda a partir do código
 * @param currencyCode Código da moeda (ex: BRL, USD)
 * @param defaultCurrency Código da moeda padrão se não for encontrado
 * @returns Símbolo da moeda
 */
export const getCurrencySymbol = (currencyCode: string, defaultCurrency: string = 'BRL'): string => {
    if (!currencyCode) return currencyMap[defaultCurrency] || defaultCurrency;
    return currencyMap[currencyCode] || currencyCode || currencyMap[defaultCurrency];
};

/**
 * Formata um valor para exibição com o símbolo da moeda
 * @param value Valor a ser formatado
 * @param currencyCode Código da moeda
 * @param defaultCurrency Código da moeda padrão
 * @returns Valor formatado com símbolo da moeda
 */
export const formatCurrencyValue = (
    value: string | number,
    currencyCode: string,
    defaultCurrency: string = 'BRL'
): string => {
    const symbol = getCurrencySymbol(currencyCode, defaultCurrency);
    const code = (currencyCode || defaultCurrency || 'BRL').toUpperCase();

    // Converter string para número de forma resiliente (aceita "9.000,00" ou "9000.00")
    const toNumber = (v: string | number): number => {
        if (typeof v === 'number') return v;
        const cleaned = v.replace(/\./g, '').replace(',', '.');
        const n = Number(cleaned);
        return isNaN(n) ? 0 : n;
    };

    if (code === 'BRL') {
        const n = toNumber(value);
        const formatted = new Intl.NumberFormat('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(n); // ex.: 9.000,00
        return `${symbol} ${formatted}`; // ex.: R$ 9.000,00
    }

    // Demais moedas: manter comportamento atual (sem separador de milhar)
    const numericValue = typeof value === 'string' ? value : value.toFixed(2).replace('.', ',');
    return `${symbol} ${numericValue}`;
};
